import React, { useEffect, useState } from "react";
import styles from "./PurchaseSuccess.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";

const PurchaseSuccess = () => {
  const navigate = useNavigate();
  const [method, setMethod] = useState("");
  const { state } = useLocation();
  const {
    paymentMethod,
    fromOnlineShopPurchase,
    fromAnnualPassPurchase,
    fromRepurchase,
  } = state;
  console.log(paymentMethod, fromOnlineShopPurchase, fromAnnualPassPurchase);

  // useEffect(() => {
  //   if (paymentMethod === "credit") {
  //     setMethod("クレジットカ");
  //   } else if (paymentMethod === "pay") {
  //     setMethod("PayPay");
  //   } else if (paymentMethod === "rakuten") {
  //     setMethod("楽天ペイオンライン");
  //   } else if (paymentMethod === "amazon") {
  //     setMethod("Amazonペイ");
  //   } else if (paymentMethod === "bank") {
  //     setMethod("銀行振込ご依頼メ");
  //   }
  // }, []);
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        {/* <div className="text-center">
          {paymentMethod === "銀行振込" && (
            <div style={{ margin: "100px 0" }}>
              <p>
                ご登録のメールアドレスへ銀行振込ご依頼のメールを送付しました。
              </p>

              <p>１週間以内にお振込手続きをお済ませ下さい。</p>

              <p> お支払い完了後に商品の編集が可能となります。</p>
            </div>
          )}
        </div> */}
        {/* Online purchase */}
        {fromOnlineShopPurchase && (
          <>
            <ShowPaymentMethodAInCard paymentMethod={paymentMethod} />
            <ThankYouDiv />
            <BlueBtnDiv />
          </>
        )}
        {fromAnnualPassPurchase && (
          <>
            <ThankYouDiv />
            <ShowPaymentMethodAInCard paymentMethod={paymentMethod} />
            <WhiteBtnDiv paymentMethod={paymentMethod} btnTxt={"マイページ"} />
          </>
        )}
        {fromRepurchase && (
          <>
            <ThankYouDiv />
            <ShowPaymentMethodAInCard paymentMethod={paymentMethod} />
            <TextDivForGalleryRepurchase />
            <WhiteBtnDiv paymentMethod={paymentMethod} btnTxt={"マイページ"} />
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

const ShowPaymentMethodAInCard = ({ paymentMethod }) => {
  return <div className={styles.header}>{paymentMethod} ド決済完了</div>;
};

const ThankYouDiv = () => {
  return <div className={styles.subtitle}>thank you so much.</div>;
};

const BlueBtnDiv = ({ paymentMethod, fromOnlineShopPurchase }) => {
  const navigate = useNavigate();
  return (
    <div
      className="d-flex flex-column align-items-center"
      style={{
        marginTop: paymentMethod === "銀行振込" ? "0px" : "100px",
        marginBottom: "115px",
      }}
    >
      <button
        onClick={() => {
          navigate("/top");
        }}
        className={`btn ${styles.buttonForRepurchase} my-4`}
      >
        アイテムを編集する
      </button>
      <p className={styles.bottomTextForRepurchase}>
        入稿してからお届けまで1ヶ月ほど頂戴しますので、お早めに編集をお済ませください。
      </p>
    </div>
  );
};

const WhiteBtnDiv = ({ paymentMethod, btnTxt }) => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        marginTop: paymentMethod === "銀行振込" ? "0px" : "100px",
        marginBottom: "40px",
      }}
    >
      <div
        onClick={() => {
          navigate("/top");
        }}
        className={`${styles.purchageSuccessBtn} my-4`}
      >
        {btnTxt}
      </div>
    </div>
  );
};

const TextDivForGalleryRepurchase = () => {
  return (
    <div
      className="mt-5 pt-5"
      style={{
        textAlign: "center",
        letterSpacing: "1.5px",
        fontSize: "15px",
        color: "#000000C7",
        fontWeight: "500",
      }}
    >
      <div>決済後、通常は1日以内にデータがアップロードされます。</div>
      <div>
        ※年末年始休業・定休日の場合は、データの反映が遅れますのでご了承ください。
      </div>
    </div>
  );
};

export default PurchaseSuccess;
